import { IP } from "@/services/config.js";
import axios from "axios";
const { aesEncrypt, aesDecrypt } = require("@/utils/crypter/aes/index");
const { rsaEncrypt, rsaDecrypt } = require("@/utils/crypter/rsa/index");
const { randomNumber } = require("@/utils/tool");
export const token =
  "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI0MTA2ZDg2MC04M2M5LTQ5MzItOTcwMC1iYTZjMzQzNmFjODgiLCJleHAiOjIwMDAwMDQwMzksInNjb3BlcyI6WyJ1c2VyIl19.mdOkdAxWofPr9yWiU9cMajpg_ueuUT_3U_oMBug0nYA";
// import { RSA } from "./crypter/rsa";
// import { AES } from "./crypter/aes";
// import { DEFAULT_PUB_KEY } from "./crypter/rsa/conf";

const isAllEncrypt = true; //是否开启全局加密
const isAllDecrypt = true; //是否开启全局解密

let baseURL = IP;
// const service = axios.create({
//     baseURL,
//     timeout:30000
// });
// console.log(DEFAULT_PUB_KEY);
export let request = axios.create({
  baseURL,
  timeout: 20000,
});
/**
 * request
 * 请求拦截器
 */
request.interceptors.request.use(
  async ({ isEncrypt = true, ...config }) => {
    // 配置请求头
    // config.headers["Authorization"] = JSON.parse(
    //   localStorage.getItem("storeToken")
    // )?.storeToken;
    // config.headers["Authorization"] = token;
    // let data = config.data;
    console.log("加密前的数据:", config.data);
    if (isAllEncrypt && isEncrypt) {
      const SECRET_KEY = randomNumber(16); //动态生成随机aes加密钥匙
      config.data = {
        key: await rsaEncrypt(SECRET_KEY),
        data: await aesEncrypt({
          data: config.data,
          SECRET_KEY,
        }),
      };
    }
    return config;
  },
  (error) => {
    console.error(error);
  }
);

/**
 * 响应拦截器
 */
request.interceptors.response.use(
  async ({ data, config, status }) => {
    const { isDecrypt = true } = config;
    if (status !== 200) {
      console.error("网络错误");
      return;
    }
    if (isAllDecrypt && isDecrypt) {
      const SECRET_KEY = await rsaDecrypt(data.key);
      const result = await aesDecrypt({
        data: data.data,
        SECRET_KEY,
      });
      console.log("解密后的数据:", result);
      return result;
    }
    return data;
  },
  (error) => {
    //处理是否为token过去 跳转到登录页
    console.log("error:", error);
  }
);
